// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"7c9c81a4","296":"88abe753","453":"aef2979e"}[chunkId] + ".chunk.js";
};